<template>
  <div class="main-component homes2">
    <div class="wrap">
      <header>RCEP培训课堂</header>
      <Row :gutter="30" class="videos">
        <Col span="6">
          <a class="item" @click.prevent="$router.push({ name: 'RcepClassroom' })" target="_blank" href="https://v.youku.com/v_show/id_XNTE2NzA5MzM0MA==.html?spm=a2h0c.8166622.PhoneSokuUgc_7.dtitle">
            <div class="thumb">
              <div class="imgWrap" :style="{background: `url(${img1}) 0 0 no-repeat transparent`, 'background-size': 'cover'}"></div>
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>通关实务</span>
          </a>
        </Col>
        <Col span="6">
          <a class="item" @click.prevent="$router.push({ name: 'RcepClassroom' })" target="_blank" href="https://v.youku.com/v_show/id_XNTE2MTMwNDc3Mg==.html?spm=a2h0c.8166622.PhoneSokuUgc_8.dtitle">
            <div class="thumb">
              <div class="imgWrap" :style="{background: `url(${img2}) 0 0 no-repeat transparent`, 'background-size': 'cover'}"></div>
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>RCEP政策</span>
          </a>
        </Col>
        <Col span="6">
          <a class="item" @click.prevent="$router.push({ name: 'RcepClassroom' })" target="_blank" href="https://v.youku.com/v_show/id_XNTE4OTQ2ODY4MA==.html?spm=a2h0c.8166622.PhoneSokuUgc_12.dtitle">
            <div class="thumb">
              <div class="imgWrap" :style="{background: `url(${img3}) 0 0 no-repeat transparent`, 'background-size': 'cover'}"></div>
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>跨境贸易</span>
          </a>
        </Col>
        <Col span="6">
          <a class="item" @click.prevent="$router.push({ name: 'RcepClassroom' })" target="_blank" href="https://v.youku.com/v_show/id_XNTgzMDcwMDUzMg==.html?spm=a2h0c.8166622.PhoneSokuUgc_22.dtitle">
            <div class="thumb">
              <div class="imgWrap" :style="{background: `url(${img4}) 0 0 no-repeat transparent`, 'background-size': 'cover'}"></div>
              <!-- <img src="//vthumb.ykimg.com/0541060161CD0AA7A818176D7D0470D6?x-oss-process=image/resize,w_1895/format,webp/interlace,1"> -->
              <div class="play-btn"><svg-icon icon-class="play2" class-name="fa-play"></svg-icon></div>
            </div>
            <span>贸易合规经理人</span>
          </a>
        </Col>
      </Row>
      <div class="recp_scope" @click="$router.push({ name: 'RcepClassroom' })">
        <img src="~@/assets/images/new_home/rcep.jpg" class="rcep">
        <div class="text">
          <div class="title">RCEP培训专区</div>
          <div class="btn">查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeS2',
  data () {
    return {
      img1: require('@/assets/images/rcep_home/1.png'),
      img2: require('@/assets/images/rcep_home/2.png'),
      img3: require('@/assets/images/rcep_home/3.png'),
      img4: require('@/assets/images/rcep_home/4.png')
    }
  }
}
</script>

<style scoped>
.main-component{
  text-align: center;
  background-color: #f6fafe;
}
header{
  color: #333;
}
.videos .item{
  max-width: 323px;
  text-align: center;
  display: block;
  /* box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2); */
  /* background-color: #fff; */
}
.videos .item img{
  width: 100%;
  display: block;
}
.videos .item span{
  padding: 16px 12px;
  font-size: 16px;
  font-weight: bold;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #333;
}
.videos .thumb{
  position: relative;
}
.imgWrap{
  width: 100%;
  height: 130px;
  border-radius: 12px;
}
.videos .thumb .play-btn{
  width: 32px;
  height: 32px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /* background-color: rgba(39, 131, 255, .8); */
  background-color: #fff;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.videos .thumb .fa-play{
  font-size: 22px;
  color: rgba(39, 131, 255);
  position: relative;
  left: 1px;
}
.recp_scope{
  position: relative;
  margin-top: 40px;
  margin-bottom: 20px;
  cursor: pointer;
}
.rcep{
  width: 100%;
  display: block;
}
.recp_scope .text{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.recp_scope .text .title{
  font-size: 26px;
  color: #fff;
  margin-bottom: 14px;
}
.recp_scope .text .btn{
  color: #fff;
  font-size: 16px;
  border: 1px solid #fff;
  padding: 5px 0;
  width: 140px;
  margin: 0 auto;
  border-radius: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/home/S2.vue